import { useContext } from 'react';
import { PresentationContext } from '@/providers/PresentationProvider/PresentationProvider';

/**
 * Access the current presentation mode + tokens.
 * Returns regular-mode defaults if not within a provider.
 */
export function usePresentation() {
  return useContext(PresentationContext);
}
